import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import { useAnalytics } from 'use-analytics';
import { t } from '@lingui/macro';
import PortalCommunication from '../../helpers/portal-comms';
import { getConfiguration } from '../../helpers/utils';
import { useTracking } from '../../analytics';
import css from './switch-to-old-assign.scss';

const SwitchToOldAssign = ({ i18n }) => {
  const { track } = useAnalytics();
  const { trackSwitchToOldAssign } = useTracking();
  async function handleSwitch() {
    const courseAssignModuleId = await getConfiguration('courseAssignModuleId');
    const oldAssignModuleId = await getConfiguration('oldAssignModuleId');

    track('SwitchToOldAssign');
    trackSwitchToOldAssign({ context: 'header-button' });

    PortalCommunication.requestModuleChange(
      oldAssignModuleId,
      courseAssignModuleId
    );
  }

  return (
    <Button
      className={css.switchToOldAssign}
      info
      type="LOZENGE"
      text={i18n._(t('switchToOldAssign')`Switch to old Assign`)}
      onClick={() => handleSwitch()}
    />
  );
};

SwitchToOldAssign.propTypes = {
  i18n: PropTypes.object
};

export default SwitchToOldAssign;



// WEBPACK FOOTER //
// ./components/switch-to-old-assign/switch-to-old-assign.js